import { render, staticRenderFns } from "./VisitApplyDetails.vue?vue&type=template&id=08ecb682&scoped=true&"
import script from "./VisitApplyDetails.vue?vue&type=script&lang=js&"
export * from "./VisitApplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./VisitApplyDetails.vue?vue&type=style&index=0&id=08ecb682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecb682",
  null
  
)

export default component.exports